module.exports = __webpack_public_path__ + "static/media/daibiao-entrance-1.b6890973.png";